import React from 'react'

// Light/dark switch for the v2 admin pages (subscribers_v2, subscriber_v2).
// Shared key, so the choice carries over between those pages.
const THEME_KEY = 'adminTheme'

export type AdminTheme = 'light' | 'dark'

function readTheme(): AdminTheme {
  try {
    const saved = localStorage.getItem(THEME_KEY)
    if (saved === 'light' || saved === 'dark') return saved
  } catch (e) {}
  return 'light'
}

// every mounted user of the theme (the page, the side menu) follows a change made by any of them
const CHANGE_EVENT = 'adminThemeChange'

export function useAdminTheme() {
  const [theme, setTheme] = React.useState<AdminTheme>(readTheme)

  React.useEffect(() => {
    const sync = () => setTheme(readTheme())
    window.addEventListener(CHANGE_EVENT, sync)
    window.addEventListener('storage', sync)
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync)
      window.removeEventListener('storage', sync)
    }
  }, [])

  const toggleTheme = React.useCallback(() => {
    const next: AdminTheme = readTheme() === 'dark' ? 'light' : 'dark'
    try {
      localStorage.setItem(THEME_KEY, next)
    } catch (e) {}
    setTheme(next)
    window.dispatchEvent(new Event(CHANGE_EVENT))
  }, [])

  return { theme, toggleTheme }
}
